/**
 * Pre-check of the Synology address before saving (GOD-51), i18n key under
 * gemeinde.synologyUrlProblems or null. The functions check the same and also
 * where the name resolves to (functions/src/inputGuards.ts). Empty = not set.
 */
export type SynologyUrlProblem = "invalid" | "https" | "path" | "private";

function privateIpv4(host: string): boolean {
    const m = host.match(/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/);
    if (!m) return false;
    const [a, b] = [Number(m[1]), Number(m[2])];
    return a === 0 || a === 10 || a === 127 || (a === 100 && b >= 64 && b <= 127) || (a === 169 && b === 254) ||
        (a === 172 && b >= 16 && b <= 31) || (a === 192 && b === 168) || a >= 224;
}

export function synologyUrlProblem(value: string): SynologyUrlProblem | null {
    const trimmed = value.trim();
    if (!trimmed) return null;
    let url: URL;
    try {
        url = new URL(trimmed);
    } catch {
        return "invalid";
    }
    if (url.protocol !== "https:") return "https";
    if (url.username || url.password || url.pathname !== "/" || url.search || url.hash) return "path";
    const host = url.hostname.replace(/^\[|\]$/g, "").toLowerCase();
    if (host.includes(":")) return /^(::1?|f[cd]|fe[89ab])/.test(host) ? "private" : null;
    if (!host.includes(".") || host === "localhost" || /\.(localhost|local|internal|lan|home|corp)$/.test(host) || privateIpv4(host)) {
        return "private";
    }
    return null;
}
